import { object, string } from 'yup'

export const ERRORS = {
    companyNameRequired: '*Company name is required',
    validContactEmail: '*Please write a valid primary contact email',
    contactEmailRequired: '*Primary contact email is required',
    contactPhoneRequired: '*Primary contact phone is required',
    validFinanceEmail: '*Please write a valid finance email',
    financeEmailRequired: '*Finance email is required',
    financePhoneRequired: '*Finance phone is required',
    validPayableEmail: '*Please write a valid account payable email',
    payableEmailRequired: '*Account payable email is required',
    companyRegNumberRequired: '*Company reg number is required',
    firstLineRequired: '*Address line 1 is required',
    cityRequired: '*City is required',
    postCodeRequired: '*Postal code is required',
    countryRequired: '*Country is required',
    vatRegNumberRequired: '*VAT number is required',
}

const schema = object().shape({
    companyName: string().required(ERRORS.companyNameRequired),
    tradingName: string().optional(),
    primaryContactEmail: string().email(ERRORS.validContactEmail).required(ERRORS.contactEmailRequired),
    primaryContactPhone: string().required(ERRORS.contactPhoneRequired),
    financeEmail: string().email(ERRORS.validFinanceEmail).required(ERRORS.financeEmailRequired),
    financePhone: string().required(ERRORS.financePhoneRequired),
    accountsPayableEmail: string().email(ERRORS.validPayableEmail).required(ERRORS.payableEmailRequired),
    companyRegNumber: string().required(ERRORS.companyRegNumberRequired),
    firstLine: string().required(ERRORS.firstLineRequired),
    secondLine: string().optional(),
    city: string().required(ERRORS.cityRequired),
    postCode: string().required(ERRORS.postCodeRequired),
    country: string().required(ERRORS.countryRequired),
    vatRegNumber: string().required(ERRORS.vatRegNumberRequired),
})

export default schema
